import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=39c6fe00&"
import script from "./TreeView.vue?vue&type=script&lang=js&"
export * from "./TreeView.vue?vue&type=script&lang=js&"
import style0 from "./TreeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTooltip,VTreeview})
